import { render, staticRenderFns } from "./shareholdingStructure.vue?vue&type=template&id=1d3516a4&scoped=true"
import script from "./shareholdingStructure.vue?vue&type=script&lang=js"
export * from "./shareholdingStructure.vue?vue&type=script&lang=js"
import style0 from "./shareholdingStructure.vue?vue&type=style&index=0&id=1d3516a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3516a4",
  null
  
)

export default component.exports